const indexItems = [
  {
    icon: 'ri-movie-2-line',
    title: '最新电影',
    desc: '院线新片、蓝光高清、各类大片一网打尽',
    count: '8,200+',
    color: 'text-primary-500 bg-primary-100',
  },
  {
    icon: 'ri-tv-2-line',
    title: '热播电视剧',
    desc: '国产、韩剧、美剧、日剧持续更新中',
    count: '5,600+',
    color: 'text-accent-500 bg-accent-100',
  },
  {
    icon: 'ri-live-line',
    title: '综艺节目',
    desc: '音乐竞演、真人秀、脱口秀精选合集',
    count: '2,400+',
    color: 'text-secondary-500 bg-secondary-100',
  },
  {
    icon: 'ri-ghost-line',
    title: '动漫番剧',
    desc: '热血、治愈、奇幻各类动漫一应俱全',
    count: '3,100+',
    color: 'text-primary-500 bg-primary-100',
  },
  {
    icon: 'ri-survey-line',
    title: '纪录片',
    desc: '自然、历史、科技纪录片深度呈现',
    count: '1,800+',
    color: 'text-accent-500 bg-accent-100',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '喜剧专场',
    desc: '爆笑喜剧电影与情景剧欢乐不停',
    count: '1,500+',
    color: 'text-secondary-500 bg-secondary-100',
  },
  {
    icon: 'ri-knife-line',
    title: '悬疑推理',
    desc: '烧脑悬疑片与高能推理剧等你来破',
    count: '980+',
    color: 'text-primary-500 bg-primary-100',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '爱情剧场',
    desc: '浪漫爱情电影与甜蜜偶像剧心动合集',
    count: '2,100+',
    color: 'text-accent-500 bg-accent-100',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            专题合集
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${item.color} group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mt-4">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm mt-1.5 line-clamp-2">{item.desc}</p>
              <span className="inline-block mt-3 text-xs font-semibold text-primary-500">
                {item.count} 部资源
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}